import Contents from "./Contents";

export default Contents;
